import React, { useState, useEffect } from "react";
import axios from "axios";
import { User, ShieldCheck, Mail, Calendar, Trash2, Search, UserCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const AdminUsers = () => {
  const { user: currentUser } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const adminToken = currentUser?.accessToken || currentUser?.token;

  // --- Users Fetch Karne ka Logic ---
  const fetchUsers = async () => {
  setLoading(true);
  try {
    // URL ko 'api/user' se badal kar 'api/users' karein
    const res = await axios.get("https://wethrift-backend.onrender.com/api/users", {
      headers: { token: `Bearer ${adminToken}` }
    });
    setUsers(res.data);
  } catch (err) {
    console.error("User fetch error:", err);
    // Agar 403 error aaye, toh check karein ki login wala user Admin hai ya nahi
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchUsers();
  }, []);

  // --- User Delete Karne ka Logic ---
  const deleteUser = async (id) => {
    if (window.confirm("Bhai, is user ko nikalna hai?")) {
      try {
        await axios.delete(`https://wethrift-backend.onrender.com/api/users/${id}`, {
          headers: { token: `Bearer ${adminToken}` }
        });
        setUsers(users.filter(u => u._id !== id));
        alert("User uda diya gaya!");
      } catch (err) {
        alert("Sirf super-admin hi user delete kar sakta hai!");
      }
    }
  };

  const filteredUsers = users.filter(u => 
    u.username?.toLowerCase().includes(searchTerm.toLowerCase()) || 
    u.email?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      
      {/* Header & Search */}
      <div className="flex flex-col md:flex-row gap-4 items-center justify-between bg-zinc-900/40 p-8 rounded-[2.5rem] border border-zinc-800/50 backdrop-blur-md">
        <div>
          <h2 className="text-2xl font-black italic tracking-tighter text-zinc-100 uppercase flex items-center gap-3">
            <UserCheck className="text-emerald-500" size={28} /> Registered Citizens
          </h2>
          <p className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest mt-1">Manage your store's community</p>
        </div>

        <div className="relative w-full md:w-80">
          <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
          <input 
            type="text" 
            placeholder="Search username or email..." 
            className="w-full bg-zinc-950/50 border border-zinc-800 pl-12 pr-4 py-3 rounded-2xl text-sm outline-none focus:border-emerald-500/50 transition-all text-zinc-300"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Users Table */}
      <div className="bg-zinc-950/50 border border-zinc-900 rounded-[2.5rem] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 border-b border-zinc-900 bg-zinc-900/20">
                <th className="p-6">User Profile</th>
                <th className="p-6">Contact Info</th>
                <th className="p-6">Account Status</th>
                <th className="p-6">Joined Date</th>
                <th className="p-6 text-right">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-900/50">
              {loading ? (
                <tr><td colSpan="5" className="p-20 text-center text-zinc-500 italic">Scanning database...</td></tr>
              ) : filteredUsers.length > 0 ? (
                filteredUsers.map((u) => (
                  <tr key={u._id} className="hover:bg-zinc-800/10 transition-colors group">
                    <td className="p-6 flex items-center gap-4">
                      <div className="w-12 h-12 bg-zinc-900 rounded-full flex items-center justify-center border border-zinc-800 group-hover:border-emerald-500/50 transition-all shadow-inner">
                        <User size={20} className="text-zinc-500" />
                      </div>
                      <div>
                        <p className="font-black text-zinc-200 uppercase tracking-tight italic">{u.username}</p>
                        <p className="text-[9px] text-zinc-600 font-mono">ID: #{u._id.slice(-6)}</p>
                      </div>
                    </td>
                    
                    <td className="p-6">
                      <div className="flex items-center gap-2 text-zinc-400">
                        <Mail size={12} className="text-emerald-500" />
                        <span className="text-xs font-medium">{u.email}</span>
                      </div>
                    </td>

                    <td className="p-6">
                      {u.isAdmin ? (
                        <span className="px-3 py-1 bg-emerald-500/10 border border-emerald-500/20 text-emerald-500 rounded-full text-[9px] font-black uppercase flex items-center w-fit gap-1">
                          <ShieldCheck size={10} /> Administrator
                        </span>
                      ) : (
                        <span className="px-3 py-1 bg-zinc-900 border border-zinc-800 text-zinc-500 rounded-full text-[9px] font-black uppercase">
                          Standard User
                        </span>
                      )}
                    </td>

                    <td className="p-6">
                      <div className="flex items-center gap-2 text-zinc-500 text-xs font-bold">
                        <Calendar size={12} />
                        {new Date(u.createdAt).toLocaleDateString('en-GB')}
                      </div>
                    </td>

                    <td className="p-6 text-right">
                      {/* Kisi ko galti se delete na kar dein, isliye condition */}
                      {u._id !== currentUser?._id && (
                        <button 
                          onClick={() => deleteUser(u._id)}
                          className="p-3 bg-zinc-900/50 rounded-xl hover:text-red-500 border border-zinc-800 hover:border-red-500/30 transition-all shadow-lg"
                        >
                          <Trash2 size={16} />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5" className="p-20 text-center text-zinc-600 uppercase tracking-widest text-[10px]">No matches found in records</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;